import React from 'react';
import SEO from '../../components/SEO/SEO';
import { useLanguage } from '../../context/LanguageContext';
import { getImprintPageStructuredData } from '../../utils/structuredData';
import './Imprint.css';

const Imprint = () => {
  const { lang, t } = useLanguage();
  const baseUrl = 'https://sentmo.com';
  const description = lang === 'de'
    ? "Impressum und rechtliche Informationen gemäß § 5 DDG für Sentmo. Kontaktdaten und verantwortliche Person."
    : "Legal notice and information pursuant to § 5 DDG for Sentmo. Contact details and responsible person.";

  return (
    <>
      <SEO
        title={t.imprint.title}
        description={description}
        keywords={lang === 'de' ? "Impressum, Rechtliche Hinweise, Kontakt, Sentmo" : "Legal Notice, Imprint, Contact, Sentmo"}
        canonicalUrl={`${baseUrl}/${lang}/imprint`}
        lang={lang}
        alternateUrls={[
          { lang: 'de', url: `${baseUrl}/de/imprint` },
          { lang: 'en', url: `${baseUrl}/en/imprint` }
        ]}
        structuredData={getImprintPageStructuredData({
          lang,
          title: t.imprint.title,
          description
        })}
      />
      <div className="page imprint-page">
        <h1>{t.imprint.title}</h1>

        <section className="imprint-section">
          <h2>{t.imprint.infoTitle}</h2>
          <p>Sven Pflüger</p>
          <p>Schusterstraße 40</p>
          <p>79098 Freiburg im Breisgau</p>
        </section>

        <section className="imprint-section">
          <h2>{t.imprint.contact}</h2>
          <p>{t.imprint.phone}: +49 176 41450810</p>
          <p>{t.imprint.email}: business.pflueger@gmail.com</p>
        </section>

        <section className="imprint-section">
          <h2>{t.imprint.responsible}</h2>
          <p>Sven Pflüger</p>
          <p>Schusterstraße 40</p>
          <p>79098 Freiburg im Breisgau</p>
        </section>

        <section className="imprint-section">
          <h2>{t.imprint.vat}</h2>
          <p>{t.imprint.vatText}</p>
        </section>

        <section className="imprint-section">
          <h2>{t.imprint.dispute}</h2>
          <p>{t.imprint.disputeText}</p>
        </section>

        <section className="imprint-section">
          <p className="source">{t.imprint.source}: eRecht24</p>
        </section>
      </div>
    </>
  );
};

export default Imprint;
